import Icon from "@ant-design/icons";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function DownloadOutlined(props) {
  return /*#__PURE__*/_jsxs(Icon, {
    ...props,
    viewBox: "0 0 512 512",
    children: [/*#__PURE__*/_jsx("path", {
      style: {
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "40px"
      },
      d: "M336,176h40a40,40,0,0,1,40,40V424a40,40,0,0,1-40,40H136a40,40,0,0,1-40-40V216a40,40,0,0,1,40-40h40"
    }), /*#__PURE__*/_jsx("polyline", {
      style: {
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "40px"
      },
      points: "176 272 256 352 336 272"
    }), /*#__PURE__*/_jsx("line", {
      style: {
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "40px"
      },
      x1: "256",
      y1: "48",
      x2: "256",
      y2: "336"
    })]
  });
}